import type { ReactNode } from "react";
import { ParallaxImage } from "@/components/parallax-image";

export function PageHero({
  eyebrow,
  title,
  lead,
  image,
  alt,
}: {
  eyebrow: string;
  title: ReactNode;
  lead?: string;
  image: string;
  alt: string;
}) {
  return (
    <header className="night relative isolate overflow-hidden pt-36 pb-20 md:pt-44 md:pb-28">
      <ParallaxImage
        name={image}
        alt={alt}
        speed={0.3}
        priority
        className="absolute inset-0 -z-10"
      />
      <div className="hero-dim absolute inset-0 -z-10" />
      <div className="shell">
        <p className="eyebrow-light animate-rise">{eyebrow}</p>
        <h1 className="display mt-5 max-w-4xl text-5xl sm:text-6xl lg:text-7xl">{title}</h1>
        {lead ? (
          <p
            className="animate-rise mt-7 max-w-xl text-[15px] leading-relaxed text-muted-foreground"
            style={{ animationDelay: "160ms" }}
          >
            {lead}
          </p>
        ) : null}
      </div>
    </header>
  );
}
